import { yes } from '@silverhand/essentials';

const normalizeEnv = (value: unknown): string | undefined =>
  value === null || value === undefined ? undefined : String(value);

export const isDevFeaturesEnabled =
  process.env.NODE_ENV !== 'production' || yes(process.env.DEV_FEATURES_ENABLED);

/** DXM magic-link gate vs classic OIDC one-time-token. Maps to `NEW_OTT_FEATURE_FLAG`. */
export const isNewOttFeatureEnabled = Boolean(yes(normalizeEnv(process.env.NEW_OTT_FEATURE_FLAG)));
